import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import router from '../libraries/router/index';
import { SENTRY_DNS, SENTRY_PROPAGATION_TARGETS } from '@Constants';
import { isAbortedRequestError } from '@Providers';

export default {
  install(app: App) {
    // NOTE :: Vue won't console AbortedRequestError since they would be just navigation logs
    app.config.errorHandler = (err, _instance, _info) => {
      if (isAbortedRequestError(err)) return;
      console.error(err);
    };

    app.config.warnHandler = (msg, _instance, _trace) => {
      if (msg.includes('AbortedRequestError')) return;
      console.warn(msg);
    };

    // NOTE :: Suppress "Uncaught (in promise) AbortedRequestError" - register at bootstrap so we run before any rejection
    window.addEventListener('unhandledrejection', (event) => {
      if (isAbortedRequestError(event.reason)) {
        event.preventDefault();
      }
    });

    if (!SENTRY_DNS || !SENTRY_PROPAGATION_TARGETS) return;

    Sentry.init({
      app,
      dsn: SENTRY_DNS,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: SENTRY_PROPAGATION_TARGETS,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      // Filter out aborted request errors - these are expected during navigation
      beforeSend(event, hint) {
        const error = hint?.originalException;
        // NOTE :: We won't send AbortedRequestError to Sentry since they are just navigation logs
        if (isAbortedRequestError(error)) return null;

        return event;
      },
    });
  },
};
